// extracted by mini-css-extract-plugin
module.exports = {"content":"style_content__zgTAh","headline":"style_headline__1FU6f","checkCircle":"style_checkCircle__L-RWx","icon":"style_icon__3acCu"};